import Logo from 'img/pdf_logo.png'
import DemoPhoneBackground2 from 'img/demo_phone_background.png'
import DemoPhoneBackgroundBg from 'img/demo_phone_background_bg.jpg'
import LinkedInIcon from 'img/icons/linkedin_2.png'
import MailIcon from 'img/icons/mail_2.png'

const body = document.getElementById('body')

// const demoPhoneBackgroundWidth = 1107
// const demoPhoneBackgroundHeight = 680
const demoPhoneBackgroundWidth = 1154
const demoPhoneBackgroundHeight = 709 + 64 + 60 + 10 // 64 footer, 60 top, 10 spazi
const scaleWidth = Math.max(window.innerWidth / demoPhoneBackgroundWidth, 0.8)
const scaleHeight = Math.max(window.innerHeight / demoPhoneBackgroundHeight, 0.8)
const scale = Math.min(1.2, scaleWidth, scaleHeight)
body!.style.backgroundImage = `url(${DemoPhoneBackgroundBg})`

const frameWrapper = document.createElement('div')
frameWrapper.className = 'frame-wrapper'
// frameWrapper.style.transform = `scale(${scale})`
// frameWrapper.style.transformOrigin = 'top'

const demoBg = document.createElement('div')
demoBg.className = 'demo-background'
demoBg.style.backgroundImage = `url(${DemoPhoneBackground2})`

const footer = document.createElement('div')
footer.className = 'footer'
footer.style.top = `${709 * scale}px`

const footerText = document.createElement('div')
footerText.className = 'footer-text'
footerText.innerHTML = 'Senseven GmbH | '

const footerText2 = document.createElement('a')
footerText2.href = 'https://www.senseven.ai/imprint'
footerText2.target = '_blank'
footerText2.className = 'footer-text2'
footerText2.innerHTML = ' Imprint'

const mailIcon = document.createElement('a')
mailIcon.href = 'mailto:office@senseven.ai'
mailIcon.className = 'mail-icon'
mailIcon.style.backgroundImage = `url(${MailIcon})`

const appointmentButton = document.createElement('a')
appointmentButton.href = 'https://meetings.hubspot.com/berezovsky'
appointmentButton.target = '_blank'
appointmentButton.className = 'appointment-button'
appointmentButton.innerHTML = 'Book a meeting'

const linkedInIcon = document.createElement('a')
linkedInIcon.href = 'https://www.linkedin.com/company/sensven/'
linkedInIcon.target = '_blank'
linkedInIcon.className = 'linkedin-icon'
linkedInIcon.style.backgroundImage = `url(${LinkedInIcon})`

const logoWrapper = document.createElement('div')
logoWrapper.className = 'logo-wrapper'

const logo = document.createElement('div')
logo.className = 'logo'
logo.style.backgroundImage = `url(${Logo})`

const title = document.createElement('div')
title.className = 'title'
title.style.backgroundImage = `url(${Logo})`

const frame = document.createElement('div')
frame.className = 'frame'

const app = document.createElement('div')
app.className = 'app'

const frameScale = document.createElement('div')
frameScale.className = 'frame-scale'
frameScale.style.transform = `scale(${scale})`
frameScale.style.transformOrigin = 'top'

const iframe: HTMLIFrameElement = document.createElement('iframe')

iframe.src = './app.html'
iframe.className = 'app-iframe-hidden'
// tslint:disable-next-line: deprecation
iframe.frameBorder = '0'
iframe.style.backgroundColor = 'white'
iframe.style.width = '100%'
iframe.style.height = '100%'
iframe.style.borderRadius = '8px'

app.append(iframe)
frame.append(app)
body!.append(logoWrapper)
logoWrapper.append(logo)
logoWrapper.append(title)

frameWrapper.append(frameScale)
frameScale.append(frame)
frameScale.append(demoBg)
frameWrapper.append(footer)

footer.append(footerText)
footer.append(footerText2)
footer.append(mailIcon)
footer.append(linkedInIcon)
footer.append(appointmentButton)

body!.append(frameWrapper)
